import React from "react";
import {
  MixedWidget1,
} from "../widgets";
export function Demo1Dashboard() {
  return (
    <>
      <div className="row">
        <div className="col-lg-12  col-xxl-12">
          <MixedWidget1 className="card-stretch gutter-b" />
        </div>
      </div>
  
    </>
  );
}
